const reclevelData = [
  { name: "Fortement recommandé", id: "high" },
  { name: "Recommandé", id: "medium" },
  { name: "Envisageable", id: "low" },
];

const statusData = [
  { name: "En cours de création", id: "creation" },
  { name: "En attente de démarrage", id: "pending" },
  { name: "En cours", id: "inprogress" },
  { name: "En pause", id: "standby" },
  { name: "Fini", id: "finished" },
];

const refConsumptionSourceData = [
  { name: "Manuelle", id: "manual" },
  { name: "Préremplir avec les données patrimoine", id: "patrimoine" },
  { name: "Préremplir avec le dispositif tertaire", id: "tertiaryBill" },
];

const dashboardDateChoiceData = [
  { id: "today", name: "Jusqu'à aujourd'hui" },
  { id: "endofyear", name: "Jusqu'à la fin de l'année" },
  { id: "3", name: "Jusqu'à N+3" },
  { id: "5", name: "Jusqu'à N+5" },
  { id: "10", name: "Jusqu'à N+10" },
  { id: "20", name: "Jusqu'à N+20" },
  { id: "30", name: "Jusqu'à N+30" },
]

const roitypesData = [
  { name: "Réelles", id: "real" },
  { name: "Projetées", id: "projected" },
]

export { reclevelData, refConsumptionSourceData, statusData, dashboardDateChoiceData, roitypesData };
